import { Element, Transforms } from 'slate';

/**
 * Moves all "list-items" from one "list" to the end of another "list".
 */
export function moveListItemsToAnotherList(editor, parameters) {
  var [sourceListNode, sourceListPath] = parameters.at;
  var [targetListNode, targetListPath] = parameters.to;

  if (Element.isElement(sourceListNode) && Element.isElement(targetListNode) && editor.isListNode(sourceListNode) && editor.isListNode(targetListNode)) {
    // Sanity check.
    for (var i = 0; i < sourceListNode.children.length; ++i) {
      Transforms.moveNodes(editor, {
        at: [...sourceListPath, 0],
        to: [...targetListPath, targetListNode.children.length + i]
      });
    }
  }
}